import { render, staticRenderFns } from "./Flyer.vue?vue&type=template&id=27a71d1b&scoped=true&"
import script from "./Flyer.vue?vue&type=script&lang=js&"
export * from "./Flyer.vue?vue&type=script&lang=js&"
import style0 from "./Flyer.vue?vue&type=style&index=0&id=27a71d1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a71d1b",
  null
  
)

export default component.exports